import React, { Component } from 'react';
import { api } from '../utils';
import CheckIcon from '../assets/icons/check.svg';

type Props = {
  onClose: Function;
  displaySelectedTimezone: Function;
  selectedBotid: string;
  selectedTimeZone: string;
};

type State = {
  timeZoneList: { timezone: string; id: number }[];
  selectedTimeZone: string;
  saveNotify: boolean;
};

export default class TimezoneList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.saveTimezone = this.saveTimezone.bind(this);
  }
  componentDidMount() {
    this.fetchTimezoneList();
  }
  setInitialState(): State {
    return {
      timeZoneList: [],
      selectedTimeZone: '(GMT+5:30) Asia/Kolkata',
      saveNotify: false,
    };
  }
  fetchTimezoneList() {
    api('getTimezoneList').then((response) => {
      this.setState({
        timeZoneList: response.map((timezone: any, index: any) => ({
          timezone: timezone,
          id: index,
        })),
      });
    });
  }
  saveTimezone() {
    let data = {
      timezone: this.state.selectedTimeZone,
      // botId: encodeURIComponent(this.props.selectedBotid),
      botId:this.props.selectedBotid,
    };
    this.setState({
      saveNotify: true,
    });
    api('setTimezone', 'POST', data).then((response) => {
      if (response) {
        this.setState(
          {
            saveNotify: false,
          },
          () => {
            this.props.onClose();
            this.props.displaySelectedTimezone(this.state.selectedTimeZone);
          }
        );
      }
    });
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (prevProps.selectedTimeZone !== this.props.selectedTimeZone) {
      this.setState({
        selectedTimeZone: this.props.selectedTimeZone,
      });
    }
  }
  render() {
    return (
      <div style={{ minWidth: '452px' }}>
        <div className='list-of-timezone-wrapper'>
          {this.state.timeZoneList.map((val, index) => {
            return (
              <div
                onClick={() => {
                  this.setState({ selectedTimeZone: val.timezone }, () =>
                    this.saveTimezone()
                  );
                }}
                className={`list-of-timezone ${
                  (
                    this.props.selectedTimeZone
                      ? this.props.selectedTimeZone === val.timezone
                      : this.state.selectedTimeZone === val.timezone
                  )
                    ? 'selected'
                    : ''
                } `}>
                {val.timezone}
                {this.state.selectedTimeZone === val.timezone ||
                  (this.props.selectedTimeZone === val.timezone && (
                    <img src={CheckIcon} alt='checkicon' />
                  ))}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
